(ns web3.icons.actions)

(def edit-pencil
  [:svg
   {:width "16px", :height "16px", :view-box "0 0 16 16", :preserve-aspect-ratio "xMidYMid meet"}
   [:defs {}]
   [:g
    {:stroke "none", :stroke-width "1", :fill "none", :fill-rule "evenodd"}
    [:g
     {:fill "currentColor"}
     [:path
      {:d "M10.3860104,2.81585316 L13.2799001,5.61636684 L3.70261657,15.1584469 L0,16 L0.741604082,12.4222963 L10.3860104,2.81585316 Z M10.9557547,2.24835149 L13.2129913,0 L16,2.90626532 L13.8495689,5.04879202 L10.9557547,2.24835149 Z"}]]]])

(def add
  [:svg
   {:width "24px", :height "24px", :view-box "0 0 24 24", :preserve-aspect-ratio "xMidYMid meet"}
   [:defs {}]
   [:g
    {:stroke "none", :stroke-width "1", :fill "none", :fill-rule "evenodd"}
    [:g
     {:transform "translate(-15.000000, -15.000000)", :fill "currentColor"}
     [:g
      {:transform "translate(15.000000, 15.000000)"}
      [:rect {:x "0", :y "11", :width "24", :height "2"}]
      [:polygon {:points "13 -0.00222195519 13 23.997778 11 23.997778 11 -0.00222195519"}]]]]])

(def undo
  [:svg {:fill "currentColor", :height "24", :view-box "0 0 24 24", :width "24", :xmlns "http://www.w3.org/2000/svg"}
   [:path {:d "M0 0h24v24H0z", :fill "none"}]
   [:path {:d "M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z"}]])


(def delete
  [:svg
   {:width "8px", :height "8px", :view-box "0 0 8 8", :preserve-aspect-ratio "xMidYMid meet"}
   [:defs {}]
   [:g
    {:stroke "none", :stroke-width "1", :fill "none", :fill-rule "evenodd"}
    [:g
     {:transform "translate(-6.000000, -6.000000)", :fill "currentColor"}
     [:path
      {:d "M9.44306342,9.44444497 L5,9.44444497 L5,10.5555561 L9.44306342,10.5555561 L9.44306342,15 L10.5541745,15 L10.5541745,10.5555561 L15,10.5555561 L15,9.44444497 L10.5541745,9.44444497 L10.5541745,5 L9.44306342,5 L9.44306342,9.44444497 Z",
       :transform "translate(10.000000, 10.000000) rotate(-225.000000) translate(-10.000000, -10.000000) "}]]]])

(def zoom
  [:svg
   {:width "17px", :height "17px", :view-box "0 0 17 17", :preserve-aspect-ratio "xMidYMid meet"}
   [:defs {}]
   [:g
    {:stroke "none", :stroke-width "1", :fill "none", :fill-rule "evenodd"}
    [:g
     {:transform "translate(-561.000000, -1703.000000)"}
     [:g
      {:transform "translate(208.000000, 1289.000000)"}
      [:g
       {:transform "translate(0.000000, 1.000000)"}
       [:g
        {:transform "translate(148.000000, 192.000000)"}
        [:g
         {:transform "translate(199.000000, 215.000000)"}
         [:g
          {:transform "translate(7.000000, 7.000000)"}
          [:polygon {:fill "currentColor", :points "9 10.7509898 14.2507425 16 16 14.25 10.7502475 9"}]
          [:path
           {:d "M10,5 C10,7.76141877 7.76141877,10 5,10 C2.23941777,10 0,7.76141877 0,5 C0,2.23858123 2.23941777,0 5,0 C7.76141877,0 10,2.23858123 10,5 Z",
            :stroke "currentColor",
            :stroke-width "1.25"}]]]]]]]]])

(def phone
  [:svg
   {:width "20px", :height "19px", :view-box "0 0 20 19", :preserve-aspect-ratio "xMidYMid meet"}
   [:defs {}]
   [:g
    {:stroke "none", :stroke-width "1", :fill "none", :fill-rule "evenodd"}
    [:g
     {:transform "translate(-283.000000, -197.000000)", :stroke "currentColor"}
     [:g
      {:transform "translate(283.000000, 197.000000)"}
      [:g
       {}
       [:path {:d "M1.42944336,2.2331543 L5.51123047,6.04345703", :stroke-linecap "square"}]
       [:path {:d "M13.6474609,13.604248 L17.6867676,17.3806152", :stroke-linecap "square"}]
       [:path
        {:d "M6.91193856,4.90493404 L6.94376302,4.8708791 C7.08714985,4.73111214 7.2288856,4.4640075 7.21527983,4.14782921 C7.21527983,3.92272911 7.08065309,3.62746604 6.76829442,3.35646809 L4.10712987,0.887129277 C3.96825562,0.717918896 3.62756383,0.517610119 3.24152037,0.502236329 C2.94902555,0.480304741 2.59596621,0.604579757 2.22834067,0.927967242 C2.15733692,0.993766616 2.07894756,1.06942625 1.97949183,1.17356214 C1.81483766,1.34596457 1.65234361,1.53558982 1.50120821,1.73909107 C1.24118197,2.08921197 1.04242384,2.44379343 0.921065767,2.80592575 C0.835978715,3.03104587 0.785258985,3.18255592 0.717656505,3.44997315 C-0.0637578443,6.54103813 0.922519701,10.2472538 5.18592323,14.1888788 L5.31144467,14.3113449 C8.44580253,17.258233 11.4968598,18.5 14.2906196,18.5 C15.5830288,18.5 16.4945706,18.2696405 17.2589964,17.9392455 C17.5906977,17.8160731 17.9321556,17.6161087 18.2697445,17.3597726 C18.6362972,17.081444 18.9171945,16.8065779 19.0999235,16.6006222 C19.4237757,16.2517167 19.5226936,15.9273924 19.4962044,15.5916942 C19.4681779,15.2502075 19.2425071,14.9282949 19.1083365,14.8498249 L19.0211365,14.7851749 L16.3974644,12.3566741 C16.0938873,12.0607609 15.8173776,11.9580831 15.531748,11.9580831 C15.2326557,11.9580831 14.9201284,12.1291076 14.7932653,12.2840712 L13.7787425,13.2466464 C13.3001332,13.6742957 12.6207795,13.7736262 12.0834393,13.4739191 C10.84104,12.8420751 9.71933484,12.0480677 8.60740321,11.0181769 L8.51105831,10.9240353 C7.40029679,9.89545141 6.53066109,8.82435018 5.85795754,7.64397745 C5.54088239,7.10310419 5.60958179,6.43345366 6.01410099,5.96028759 L6.91193856,4.90493404 Z",
         :fill-rule "nonzero"}]]]]]])